import React from 'react';
import { useTranslation } from 'react-i18next';
import { map } from 'lodash';
import { useFormikContext } from 'formik';

import { tOrdinalItem } from '@components/i18n';
import { MemberAnswerItem } from './member-answer-item';
import { FormValues } from '../type';

type Props = {
  questionIdx: number;
};

const MemberAnswerList = ({ questionIdx }: Props) => {
  const { t } = useTranslation();
  const { values } = useFormikContext<FormValues>();

  return (
    <>
      <MemberAnswerItem
        age={values.me.age}
        label={`${t('common:myself')}`}
        name={`me.medicalAnswers.${questionIdx}.remark`}
        isVisible={values.me.medicalAnswers[questionIdx]?.answer == 'yes'}
      />

      {values.spouse && (
        <MemberAnswerItem
          age={values.spouse.age}
          label={`${t('common:spouse')}`}
          name={`spouse.medicalAnswers.${questionIdx}.remark`}
          isVisible={values.spouse.medicalAnswers[questionIdx]?.answer == 'yes'}
        />
      )}

      {!!values.sons && map(values.sons, (son, idx) =>
        <MemberAnswerItem
          key={idx}
          age={son.age}
          label={tOrdinalItem(idx + 1, 'common:son')}
          name={`sons.${idx}.medicalAnswers.${questionIdx}.remark`}
          isVisible={son.medicalAnswers[questionIdx]?.answer == 'yes'}
        />
      )}

      {!!values.daughters && map(values.daughters, (daughter, idx) =>
        <MemberAnswerItem
          key={idx}
          age={daughter.age}
          label={tOrdinalItem(idx + 1, 'common:daughter')}
          name={`daughters.${idx}.medicalAnswers.${questionIdx}.remark`}
          isVisible={daughter.medicalAnswers[questionIdx]?.answer == 'yes'}
        />
      )}
    </>
  );
};

export { MemberAnswerList };
